import Scrollbar from 'perfect-scrollbar';
import MicroModal from 'micromodal';
export default class ClickAndCollect {
    static initShopClick() {
        if (this.modal === null) {
            return;
        }
        this.modal.querySelectorAll('.modal-shop__shop').forEach((shopTile) => {
            const shopTileDataset = shopTile.dataset;
            if (this.modal && this.selectedId && shopTileDataset.shopId) {
                if (shopTileDataset.shopId === this.selectedId) {
                    shopTile.classList.add('selected');
                }
                else {
                    shopTile.classList.remove('selected');
                }
            }
            shopTile.addEventListener('click', (e) => {
                e.preventDefault();
                if (this.modal && !shopTile.classList.contains('out-of-stock')) {
                    this.modal.querySelectorAll('.modal-shop__shop').forEach((elem) => {
                        elem.classList.remove('selected');
                    });
                    const shopId = shopTileDataset.shopId;
                    if (shopId) {
                        shopTile.classList.add('selected');
                        this.selectedId = shopId;
                        this.modal.dataset.selectedId = shopId;
                        this.updateActionButtons();
                    }
                }
            });
        });
    }
    static updateActionButtons() {
        if (this.modal === null) {
            return;
        }
        const selectBtn = this.modal.querySelector('.choose-shop');
        const clearBtn = this.modal.querySelector('.clear-selection');
        if (!clearBtn || !selectBtn) {
            return;
        }
        if (this.selectedId) {
            clearBtn.style.display = 'block';
            selectBtn.classList.remove('disabled');
            selectBtn.removeAttribute('disabled');
        }
        else {
            clearBtn.style.display = 'none';
            selectBtn.classList.add('disabled');
            selectBtn.setAttribute('disabled', 'disabled');
        }
    }
    static initActionButtons() {
        if (this.modal === null) {
            return;
        }
        const selectBtn = this.modal.querySelector('.choose-shop');
        const clearBtn = this.modal.querySelector('.clear-selection');
        if (!clearBtn || !selectBtn) {
            return;
        }
        clearBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.selectedId = null;
            if (!this.modal) {
                return;
            }
            this.modal.dataset.selectedId = '';
            this.modal.querySelectorAll('.modal-shop__shop').forEach((shopTile) => {
                shopTile.classList.remove('selected');
            });
            selectBtn.classList.add('disabled');
            selectBtn.setAttribute('disabled', 'disabled');
            clearBtn.style.display = 'none';
            fetch('/shop/clearchoice', {
                method: 'POST',
                cache: 'no-cache',
            })
                .then((response) => {
                if (response.ok === false) {
                    throw new Error('Unknown failure');
                }
                return response.json();
            })
                .then(() => {
                //.cc-choose-shop
                const shopInfoBox = document.querySelector('.product-card__overview-shop');
                const chooseShop = document.querySelector('.cc-choose-shop');
                if (shopInfoBox) {
                    shopInfoBox.style.display = 'none';
                }
                if (chooseShop) {
                    chooseShop.dataset.shopId = '';
                    chooseShop.style.display = 'block';
                }
                this.updateView(null);
            })
                .catch((err) => {
                console.error(err);
            });
        });
        selectBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            const formData = new FormData();
            if (this.skus) {
                formData.append('skus', this.skus);
            }
            if (this.selectedId) {
                formData.append('shopId', this.selectedId);
            }
            fetch('/shop/select', {
                method: 'POST',
                cache: 'no-cache',
                body: formData,
            })
                .then((response) => {
                if (response.ok === false) {
                    throw new Error('Unknown failure');
                }
                return response.json();
            })
                .then((response) => {
                this.updateView(response);
            })
                .catch((err) => {
                console.error(err);
            });
        });
    }
    static setInitialData() {
        if (this.modal) {
            const modalDataset = this.modal.dataset;
            if (modalDataset.city) {
                this.city = modalDataset.city;
            }
            if (modalDataset.remote) {
                this.remoteUrl = modalDataset.remote;
            }
            if (modalDataset.skus) {
                this.skus = modalDataset.skus;
            }
            if (typeof modalDataset.shopId !== 'undefined' && modalDataset.shopId !== 'undefined') {
                this.selectedId = modalDataset.shopId;
            }
        }
    }
    static updateView(data) {
        const shopInfoBox = document.querySelector('.product-card__overview-shop');
        if (shopInfoBox) {
            const shopInfoNameElement = shopInfoBox.querySelector('.product-card__overview-shop-info-name');
            const shopInfoAddress = shopInfoBox.querySelector('.product-card__overview-shop-info-address');
            const shopInfoStock = shopInfoBox.querySelector('.shop-stock-value');
            const chooseShopButton = document.querySelector('.product-card__overview-tip .cc-choose-shop');
            const changeShopButton = document.querySelector('.product-card__overview-shop .js-cc-choose-shop');
            if (data && data.shop.id) {
                shopInfoBox.style.display = 'block';
                if (shopInfoNameElement) {
                    shopInfoNameElement.innerText = data.shop.name;
                }
                let apartmentNumber = '';
                if (data.shop.address.apartmentNumber !== '' && data.shop.address.apartmentNumber !== null) {
                    apartmentNumber = '/' + data.shop.address.apartmentNumber;
                }
                const address = data.shop.address.street +
                    ' ' +
                    data.shop.address.buildingNumber +
                    apartmentNumber +
                    '<br>' +
                    data.shop.address.postcode +
                    ' ' +
                    data.shop.address.city;
                if (shopInfoAddress) {
                    shopInfoAddress.innerHTML = address;
                    shopInfoAddress.style.display = 'block';
                }
                const stockValue = data.firstSkuStock;
                if (shopInfoStock) {
                    const shopInfoStockAvailable = shopInfoBox.querySelector('.cic-product-available');
                    const shopInfoStockUnavailable = shopInfoBox.querySelector('.cic-product-unavailable');
                    if (stockValue && stockValue > 0) {
                        shopInfoStock.innerText = stockValue.toString();
                        if (shopInfoStockAvailable && shopInfoStockUnavailable) {
                            shopInfoStockAvailable.style.display = 'block';
                            shopInfoStockUnavailable.style.display = 'none';
                        }
                    }
                    else {
                        if (shopInfoStockAvailable && shopInfoStockUnavailable) {
                            shopInfoStockAvailable.style.display = 'none';
                            shopInfoStockUnavailable.style.display = 'block';
                        }
                    }
                }
                if (chooseShopButton) {
                    chooseShopButton.style.display = 'none';
                }
                if (changeShopButton) {
                    changeShopButton.dataset.shopId = data.shop.id.toFixed(0);
                }
            }
            else {
                shopInfoBox.style.display = 'none';
                if (chooseShopButton) {
                    chooseShopButton.style.display = 'block';
                }
            }
            if (this.modal) {
                MicroModal.close(this.modal.id);
            }
        }
        window.dispatchEvent(new CustomEvent('selected-cc-shop', {
            detail: data,
            bubbles: true,
        }));
    }
    static initSelected() {
        const shopElement = document.querySelector('.product-card__overview-shop');
        if (shopElement) {
            const productSku = document.querySelector('.product-card__overview-info-ref .product_sku');
            let skus = null;
            if (productSku) {
                skus = productSku.innerText;
            }
            const formData = new FormData();
            if (skus) {
                formData.append('skus', skus);
            }
            fetch('/shop/getselected', {
                method: 'POST',
                cache: 'no-cache',
                body: formData,
            })
                .then((response) => {
                if (response.ok === false) {
                    throw new Error('Unknown failure');
                }
                return response.json();
            })
                .then((response) => {
                this.updateView(response);
            })
                .catch((err) => {
                console.error(err);
            });
        }
    }
    static initProductCardClearButton() {
        const clearShopSelection = document.querySelector('.js-cc-clear-shop');
        if (clearShopSelection) {
            clearShopSelection.addEventListener('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                fetch('/shop/clearchoice', {
                    method: 'POST',
                    cache: 'no-cache',
                })
                    .then((response) => {
                    if (response.ok === false) {
                        throw new Error('Unknown failure');
                    }
                    return response.json();
                })
                    .then(() => {
                    const shopInfoBox = document.querySelector('.product-card__overview-shop');
                    const chooseShop = document.querySelector('.cc-choose-shop');
                    if (shopInfoBox) {
                        shopInfoBox.style.display = 'none';
                    }
                    if (chooseShop) {
                        chooseShop.dataset.shopId = '';
                        chooseShop.style.display = 'block';
                    }
                    this.updateView(null);
                })
                    .catch((err) => {
                    console.error(err);
                });
            });
        }
    }
    static initFindShop() {
        if (!this.modal) {
            return;
        }
        const cityShops = this.modal.querySelector('#cityshops');
        if (cityShops) {
            cityShops.addEventListener('keyup', (e) => {
                let code;
                if (e.key !== undefined) {
                    code = e.key;
                }
                else if (e.keyCode !== undefined) {
                    code = e.keyCode;
                }
                const keyEnter = 'Enter';
                if (code === keyEnter) {
                    e.preventDefault();
                    const city = cityShops.value;
                    if (this.modal) {
                        this.modal.dataset.city = city;
                        this.city = city;
                        this.reloadModalData();
                    }
                }
            });
        }
        const findShopButton = this.modal.querySelector('.find-shop');
        if (findShopButton) {
            findShopButton.addEventListener('click', (e) => {
                e.preventDefault();
                if (this.modal && cityShops) {
                    this.modal.dataset.city = cityShops.value;
                    this.city = cityShops.value;
                    this.reloadModalData();
                }
            });
        }
    }
    static initShowAllCities() {
        if (!this.modal) {
            return;
        }
        const showAllCitiesBtn = this.modal.querySelector('.js-show-all-cities');
        if (showAllCitiesBtn) {
            showAllCitiesBtn.addEventListener('click', (e) => {
                e.preventDefault();
                if (this.modal) {
                    const cityShops = this.modal.querySelector('#cityshops');
                    if (cityShops) {
                        cityShops.value = '';
                    }
                    this.city = '';
                    this.modal.dataset.city = '';
                    this.reloadModalData();
                }
            });
            if (!this.city) {
                showAllCitiesBtn.style.display = 'none';
            }
            else {
                showAllCitiesBtn.style.display = 'block';
            }
        }
    }
    static reloadModalData() {
        if (!this.modal) {
            return;
        }
        if (this.remoteUrl) {
            const formData = new FormData();
            if (this.skus) {
                formData.append('skus', this.skus);
            }
            if (this.city) {
                formData.append('search', this.city);
            }
            fetch(this.remoteUrl, {
                method: 'POST',
                cache: 'no-cache',
                body: formData,
            })
                .then((response) => {
                if (response.ok === false) {
                    throw new Error('Unknown failure');
                }
                return response.text();
            })
                .then((response) => {
                if (this.modal) {
                    const modalContent = this.modal.querySelector('.content');
                    const cityShops = this.modal.querySelector('#cityshops');
                    if (modalContent && cityShops) {
                        modalContent.innerHTML = response;
                        if (this.city) {
                            cityShops.value = this.city;
                        }
                        this.initShopClick();
                        this.initActionButtons();
                        this.initShowAllCities();
                        this.initFindShop();
                        this.initScrollbar();
                        this.updateActionButtons();
                    }
                }
            })
                .catch((err) => {
                console.error(err);
            });
        }
    }
    static initScrollbar() {
        new Scrollbar('.shop-list-scroll', {
            wheelSpeed: 2,
            wheelPropagation: false,
            minScrollbarLength: 20,
        });
    }
    static initModal(modal) {
        this.modal = modal;
        const selectedShop = this.modal.querySelector('.modal-shop__shop.selected');
        if (selectedShop !== null) {
            this.selectedId = typeof selectedShop.dataset.shopId === 'undefined' ? null : selectedShop.dataset.shopId;
        }
        this.setInitialData();
        this.initShopClick();
        this.initActionButtons();
        this.updateActionButtons();
        this.initShowAllCities();
        this.initFindShop();
        this.initScrollbar();
    }
}
ClickAndCollect.modal = null;
ClickAndCollect.selectedId = null;
ClickAndCollect.skus = null;
ClickAndCollect.city = null;
ClickAndCollect.remoteUrl = null;
